import React, { useContext } from 'react';

import { ContentContext } from 'Components/hooks/context';
import Referral from './Referral';
import classnames from 'classnames';
import { component } from './styles.module.scss';

const ReutersReferrals = () => {
  const { common, template } = useContext(ContentContext);
  const referrals = template.reutersLinks;

  if (referrals.length === 0) return null;
  const Referrals = referrals.slice(0, 3).map((referral, i) => (
    <Referral {...referral} key={i} />
  ));
  return (
    <div className={classnames(component)}>
      <div className='section-spacer' />
      <div className='referral-box'>
        <div className='section-spacer-internal' />
        <div>
          <h3>{common.referrals.title}</h3>
          <div className='referral-links-container'>
            {Referrals}
          </div>
        </div>
        <div className='section-spacer-internal' />
      </div>
      <div className='section-spacer' />
    </div>
  );
};

export default ReutersReferrals;
